import React from "react";
import Global from '../components/global'
import ReactModal from 'react-modal'
import SlidesContainer from "../components/slidesContainer";

import "../styles/main.scss"
import Page from "../components/page";
import SEO from "../components/seo"

ReactModal.setAppElement('#___gatsby')

const metaDescription = "Start your career in Commercial Road Transport with a MITO Micro credential."

export default function Home() {
  return (
    <Page>
      <SEO title="Automotive Engineering Intro" description={metaDescription} />
      <Global />
      <SlidesContainer />
    </Page>
  )
}
